import { ApiQuery, SortDirections, SortQuery } from "~/modules/filters/types";
import { useState } from "react";
import { sortItemsByProperty } from "~/utils/functions/sortItemsByProperty";
import { TopTransfer, TopTransferColumns } from "./types";

// // // //

/**
 * SORT_MAP
 * Map each AssetColumns to a key used to in-memory sort the array of items using `sortItemsByNestedProperty`
 */
const SORT_MAP: Record<TopTransferColumns, string> = {
    [TopTransferColumns.rank]: "rank",
    [TopTransferColumns.asset]: "asset_name",
    [TopTransferColumns.timestamp]: "timestamp",
    [TopTransferColumns.usdAmount]: "usd_amount",
    [TopTransferColumns.network]: "network_name",
};

// // // //

// ENHANCEMENT - update this to accept an optional ApiQuery object for the default query value
export function useInMemoryTopTransferSort(props: {
    rows: TopTransfer[];
    sort?: SortQuery;
}) {
    const {
        rows,
        sort = {
            field: TopTransferColumns.usdAmount,
            direction: SortDirections.desc,
        },
    } = props;

    const [query, setQuery] = useState<ApiQuery>({
        sort,
        pagination: {
            page: 1,
            perPage: 25,
        },
    });

    const sortedItems = sortItemsByProperty({
        items: rows,
        field: SORT_MAP[query.sort.field as TopTransferColumns],
        direction: query.sort.direction,
        nullsLast: true,
        caseSensitive: false,
    }).map((item, index) => {
        return {
            ...item,
            rank: index + 1,
        };
    });

    return { query, setQuery, sortedItems };
}
